import React from "react";
import moment from "moment-timezone";

export default function GetRemainOnlyDays({ enddate }) {
  if (!enddate) return null;

  const today = moment().startOf("day");
  const end = moment(enddate).startOf("day");

  const diff = end.diff(today, "days"); // Positive if future, negative if past
  const absDays = Math.abs(diff);

  let message = "";
  if (diff > 0) {
    message = `${absDays} day${absDays > 1 ? "s" : ""} left`;
  } else if (diff < 0) {
    message = `${absDays} day${absDays > 1 ? "s" : ""} delay`;
  } else {
    message = `Due today`;
  }

  const color = diff < 0 ? "red" : "green";

  return (
    <span
      className="deadline-p d-flex align-items-center"
      style={{ columnGap: "10px" }}
    >
      <i
        className="fa-regular fa-clock"
        aria-hidden="true"
        style={{ color }}
      ></i>
      <p style={{ color, marginBottom: 0 }}>{message}</p>
    </span>
  );
}
